import { useEffect } from 'react';
import { useAuth } from './useAuth';

/**
 * Hook to sync user data from backend when authentication state changes
 * This ensures we always have the latest role and company information
 */
export const useUserSync = () => {
  const { state, user, refreshToken } = useAuth();

  useEffect(() => {
    // Only sync if we're authenticated but don't have backend data yet
    if (state === 'AUTHENTICATED' && user && !user.company) {
      // This means we only have Cognito data, try to get backend data
      const syncUserData = async () => {
        try {
          await refreshToken(); // Force a refresh to get latest data
        } catch (error) {
          console.error('Failed to sync user data:', error);
        }
      };

      syncUserData();
    }
  }, [state, user, refreshToken]);
};
